import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromRailroadDetailState from './railroad-detail.reducer';
import { RailroadDetailEffects } from './railroad-detail.effects';
import { RailroadLogoEffects } from '../general-info/railroad-logo/railroad-logo.effects';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromRailroadDetailState.railroadDetailFeatureKey,
			fromRailroadDetailState.reducer
		),
		EffectsModule.forFeature([RailroadDetailEffects, RailroadLogoEffects]),
	],
})
export class RailroadDetailStateModule {}
